import { createBrowserRouter, Navigate, type RouteObject } from 'react-router-dom';
import { AppLayout } from '@/components/layout/AppLayout';
import { RequireAuth } from '@/components/auth/RequireAuth';
import { RequireRole } from '@/components/auth/RequireRole';
import { LoginPage } from '@/pages/LoginPage';
import { DashboardPage } from '@/pages/DashboardPage';
import { NotFoundPage } from '@/pages/NotFoundPage';
import { PlaceholderPage } from '@/pages/PlaceholderPage';
import { ClientsPage } from '@/pages/admin/ClientsPage';
import { EngagementsPage } from '@/pages/admin/EngagementsPage';
import { ActivitiesPage } from '@/pages/admin/ActivitiesPage';
import { ClockPage } from '@/pages/ClockPage';
import { ClockLogPage } from '@/pages/reports/ClockLogPage';
import { TimesheetPage } from '@/pages/TimesheetPage';
import { TimesheetReportPage } from '@/pages/reports/TimesheetReportPage';

const routes: RouteObject[] = [
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/',
    element: (
      <RequireAuth>
        <AppLayout />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <DashboardPage /> },
      {
        path: 'timesheet',
        element: <TimesheetPage />,
      },
      {
        path: 'clock',
        element: <ClockPage />,
      },
      {
        path: 'reports/timesheet',
        element: (
          <RequireRole atLeast="Manager">
            <TimesheetReportPage />
          </RequireRole>
        ),
      },
      {
        path: 'reports/clock',
        element: (
          <RequireRole atLeast="Manager">
            <ClockLogPage />
          </RequireRole>
        ),
      },
      {
        path: 'admin/clients',
        element: (
          <RequireRole atLeast="Manager">
            <ClientsPage />
          </RequireRole>
        ),
      },
      {
        path: 'admin/engagements',
        element: (
          <RequireRole atLeast="Manager">
            <EngagementsPage />
          </RequireRole>
        ),
      },
      {
        path: 'admin/activities',
        element: (
          <RequireRole atLeast="Manager">
            <ActivitiesPage />
          </RequireRole>
        ),
      },
      {
        path: 'admin/locations',
        element: (
          <RequireRole atLeast="Manager">
            <PlaceholderPage title="Locations" phase="Phase 4" />
          </RequireRole>
        ),
      },
      {
        path: 'admin/employees',
        element: (
          <RequireRole atLeast="Manager">
            <PlaceholderPage title="Employees" phase="Phase 4" />
          </RequireRole>
        ),
      },
      {
        path: 'admin/users',
        element: (
          <RequireRole anyOf={['Admin']}>
            <PlaceholderPage title="Users" phase="Phase 4" />
          </RequireRole>
        ),
      },
      {
        path: 'admin/audit',
        element: (
          <RequireRole anyOf={['Admin']}>
            <PlaceholderPage title="Audit log" phase="Phase 5" />
          </RequireRole>
        ),
      },
    ],
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
  // Catch missing root → /login if not authed (handled by RequireAuth above).
  {
    path: '/logout',
    element: <Navigate to="/login" replace />,
  },
];

export const router = createBrowserRouter(routes);
